const DEV_API_ORIGIN = 'https://devapi.r8trapp.com';
const PROD_API_ORIGIN = 'https://api.r8trapp.com';

const isProductionOrigin = (origin: string): boolean => {
  return (
    origin === 'https://r8trapp.com' || origin === 'https://www.r8trapp.com'
  );
};

const apiOriginFor = (origin: string): string => {
  return isProductionOrigin(origin) ? PROD_API_ORIGIN : DEV_API_ORIGIN;
};

export const resolveApiBase = (origin: string): string => {
  return `${apiOriginFor(origin)}/api/`;
};

export const resolveSocketUrl = (origin: string): string => {
  return `${apiOriginFor(origin)}/`;
};
